import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "absolute top-0 -right-1 flex items-center justify-center w-3 h-3 bg-gray-700 rounded-full"
}
const _hoisted_2 = { class: "text-gray-100 text-[8px]" }

import { PartnerProviderType } from '@/http/customerSession';
import { faSquareInstagram, faSquareWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProviderIcon',
  props: {
    provider: {
        type: String as PropType<PartnerProviderType>,
        default: () => { return 'WHATSAPP'; }
    },
    providerOrder: {
        type: String,
        default: undefined,
        required: false,
    }
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.provider === 'WHATSAPP')
      ? (_openBlock(), _createBlock(_unref(FontAwesomeIcon), {
          key: 0,
          icon: _unref(faSquareWhatsapp),
          class: "relative text-green-600 bg-white rounded-full h-6 w-6"
        }, null, 8, ["icon"]))
      : _createCommentVNode("", true),
    (props.provider === 'INSTAGRAM')
      ? (_openBlock(), _createBlock(_unref(FontAwesomeIcon), {
          key: 1,
          icon: _unref(faSquareInstagram),
          class: "relative rounded-full text-[#dd2a7b] h-6 w-6"
        }, null, 8, ["icon"]))
      : _createCommentVNode("", true),
    (__props.providerOrder !== undefined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(__props.providerOrder), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})